/**
 * Normalizes city names to make searches accent and case insensitive.
 *
 * @param {string} cityName Name to normalize.
 * @return {string} Name without diacritics, in lower case.
 */
export function normalizeCityName(cityName: string): string {
    return cityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
        .replace(/ñ/g, "n")
        .replace(/Ñ/g, "N")
        .replace(/ç/g, "c")
        .replace(/Ç/g, "C")
        .toLowerCase();
}
